import { render, staticRenderFns } from "./ThePlugin.vue?vue&type=template&id=28276fd0&scoped=true&"
import script from "./ThePlugin.vue?vue&type=script&lang=js&"
export * from "./ThePlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28276fd0",
  null
  
)

export default component.exports